/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Develop = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    id="a95845fb-6481-41ee-ad1a-3c85fae1fb8c"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <defs>
      <style>
        {
          ".a8abe490-bbb8-4bd2-b8fc-72061f8334e5{fill:#fff}.b018e8ae-cbf2-4e75-aa5b-472510557190,.b3d2e27f-2adf-4b38-bbcb-ea39e07538e8{fill:none;stroke:#3f20ba;stroke-linecap:round;stroke-linejoin:round;stroke-width:.5px}.b3d2e27f-2adf-4b38-bbcb-ea39e07538e8{fill:#d9cfff}.acf0186e-4a5d-4226-bdd7-4bda9962151d{fill:#3f20ba}"
        }
      </style>
    </defs>
    <path
      d="M21.31 8.76a1.53 1.53 0 0 0-.75-1.29l-9.15-5.28a1 1 0 0 0-1 0L10 2.4l9.9 5.71a1 1 0 0 1 .5.87v7.92l-6.9 4a1 1 0 0 1-1 0l-9.85-5.73v.43a1 1 0 0 0 .5.86l9.14 5.28a1.49 1.49 0 0 0 1.5 0L21 17.59a.75.75 0 0 0 .37-.66z"
      className="a8abe490-bbb8-4bd2-b8fc-72061f8334e5"
    />
    <path
      d="M13.54 20.89l6.9-4L10 10.9l-7.35 4.27 9.89 5.72a1 1 0 0 0 1 0z"
      className="a8abe490-bbb8-4bd2-b8fc-72061f8334e5"
    />
    <path
      d="M10 10.9l10.4 6V9a1 1 0 0 0-.5-.87L10 2.4z"
      className="a8abe490-bbb8-4bd2-b8fc-72061f8334e5"
    />
    <path
      d="M13.54 20.89l6.9-4L10 10.9l-7.35 4.27 9.89 5.72a1 1 0 0 0 1 0z"
      className="b018e8ae-cbf2-4e75-aa5b-472510557190"
    />
    <path
      d="M10 10.9l10.4 6V9a1 1 0 0 0-.5-.87L10 2.4z"
      className="b018e8ae-cbf2-4e75-aa5b-472510557190"
    />
    <path
      d="M16.93 18.92l2.21-1.27-10.4-6-2.2 1.27 10.39 6zM10.22 18.3l1.77-1.02-2.6-1.5-1.76 1.02 2.59 1.5z"
      className="b3d2e27f-2adf-4b38-bbcb-ea39e07538e8"
    />
    <path
      d="M2.65 15.17v.43a1 1 0 0 0 .5.86l9.14 5.28a1.49 1.49 0 0 0 1.5 0L21 17.59a.75.75 0 0 0 .37-.66V8.76a1.53 1.53 0 0 0-.75-1.29l-9.21-5.28a1 1 0 0 0-1 0L10 2.4"
      className="b018e8ae-cbf2-4e75-aa5b-472510557190"
    />
    <path
      d="M14.37 12.15l6.19 3.29a.24.24 0 0 1 .1.33.24.24 0 0 1-.33.11zM14.37 11.15l6.19 3.29a.24.24 0 0 1 .1.33.24.24 0 0 1-.33.11zM14.37 10.15l6.19 3.29a.24.24 0 0 1 .1.33.24.24 0 0 1-.33.11zM14.37 9.15l6.19 3.29a.24.24 0 0 1 .1.33.24.24 0 0 1-.33.11zM14.37 8.15l6.19 3.29a.24.24 0 0 1 .1.33.24.24 0 0 1-.33.11zM14.37 7.15l6.19 3.29a.24.24 0 0 1 .1.33.24.24 0 0 1-.33.11zM14.37 6.15l6.19 3.29a.24.24 0 0 1 .1.33.24.24 0 0 1-.33.11z"
      className="acf0186e-4a5d-4226-bdd7-4bda9962151d"
    />
  </svg>
));
